// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../.config/yarn/global/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body-card[data-v-1e919cec]{overflow-y:auto}.emote-body[data-v-1e919cec]{width:100%;overflow-x:auto}.myemote[data-v-1e919cec]{font-size:50px;height:80px;width:80px;border:1px solid #272f75;border-radius:40px;justify-content:center}.emoteoptions[data-v-1e919cec],.myemote[data-v-1e919cec]{cursor:pointer;display:flex}.emoteoptions[data-v-1e919cec]{font-size:15px;flex-grow:0}", ""]);
// Exports
module.exports = exports;
